    import React, { useMemo, forwardRef } from "react";
import Select from "react-select";

const CustomSelect = forwardRef(({
  id,
  name,
  data = [],
  value,
  onChange,
  isDisabled = false,
  placeholder,
  valueKey,
  labelKey, // Optional
  additionalFields = []
}, ref) => {
  // console.log(valueKey, labelKey, additionalFields);

  const getNestedValue = (obj, key) => {
    return key?.split('.').reduce((acc, part) => acc && acc[part], obj);
  };

  const options = useMemo(() =>

    data.map(option => {
      let val = getNestedValue(option, valueKey);
      let label = labelKey ? getNestedValue(option, labelKey) : undefined;

      // Fallback: check nested object values if not found
      if ((val === undefined || (labelKey && label === undefined))) {
        const nestedObject = Object.values(option).find(obj =>
          obj && typeof obj === "object" && getNestedValue(obj, valueKey) !== undefined
        );
        if (nestedObject) {
          val = getNestedValue(nestedObject, valueKey);
          label = labelKey ? getNestedValue(nestedObject, labelKey) : undefined;
        }
      }

      // If labelKey is not provided, use only valueKey
      let fieldValues;
      if (!labelKey) {
        fieldValues = [val || "N/A"];
      } else {
        fieldValues = [
        //   val || "N/A",
          label || "N/A",
          ...additionalFields.map(field => option[field] || "N/A")
        ];
      }

      return {
        value: val,
        label: fieldValues.join(" - "),
        searchString: fieldValues.join(" ").toLowerCase()
      };
    }), [data, valueKey, labelKey, additionalFields]
  );

  const customFilter = (option, inputValue) => {
    return option.data.searchString.includes(inputValue.toLowerCase());
  };

  return (
    <Select
      ref={ref}
      id={id}
      name={name}
      options={options}

      value={options.find(option => option.value === value) || null}
      onChange={selectedOption =>
        onChange({ target: { name, value: selectedOption?.value || "" } })
      }
      isDisabled={isDisabled}
      isSearchable={false}
      placeholder={placeholder}
      required={true}
      filterOption={false}
      // ✅ This makes the menu render outside the modal container to avoid z-index issues
      menuPortalTarget={document.body}
      styles={{
         control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#9ee4ffff" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 1px #9ee4ffff" : "none",
      borderRadius: "4px",
      minHeight: "40px",
      "&:hover": {
        borderColor: "",
      },
    }),
         option: (base, state) => ({
      ...base,
      backgroundColor:  state.isFocused
        ? "#6fd6ffff"
        : "#fff",
      color: state.isFocused ? "#333" : "#333",
      padding: 10,
      cursor: "pointer",
      "&:active": {
        // backgroundColor: "#2684FF",
        // color: "#fff",
      },
    }),
        menuPortal: base => ({ ...base, zIndex: 9999}),
        menu: base => ({ ...base, zIndex: 9999})
      }}
      
    />
  );
});

export default React.memo(CustomSelect);
